"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/es/select/style");
var _select = _interopRequireDefault(require("antd/es/select"));
var _react = _interopRequireWildcard(require("react"));
var _forceLabelInValue = _interopRequireDefault(require("./forceLabelInValue"));
var _redux = require("redux");
var _MockInfiniteScroll = _interopRequireDefault(require("./MockInfiniteScroll"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const infinteScrollSelect = function () {
  let Comp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _select.default;
  return class InfinteScrollSelect extends _react.Component {
    render() {
      const {
        limit = 100,
        ...props
      } = this.props;
      const count = _react.default.Children.count(props.children);
      if (count <= limit) return /*#__PURE__*/_react.default.createElement(Comp, props);
      const dataSource = _react.default.Children.toArray(props.children);
      const {
        filterOption,
        optionFilterProp = "children",
        onSearch,
        onPopupScroll,
        onDropdownVisibleChange
      } = props;
      let optionFilterFn = (input, option) => {
        if (!input) return true;
        if (typeof filterOption === "function") {
          return filterOption(input, option);
        }
        return search(option.props[optionFilterProp], input);
      };
      return /*#__PURE__*/_react.default.createElement(_MockInfiniteScroll.default, {
        dataSource: dataSource,
        pageSize: limit,
        filter: optionFilterFn
      }, (items, handleSearch, handleNext, handleOpenClose) => {
        return /*#__PURE__*/_react.default.createElement(Comp, _extends({}, props, {
          children: items,
          onSearch: joinFunctions(onSearch, handleSearch),
          onPopupScroll: joinFunctions(onPopupScroll, ev => {
            if (ev) {
              ev.persist();
              const element = ev.target;
              if (element) {
                if (element.scrollHeight - element.scrollTop <= element.clientHeight) {
                  // do something at end of scroll
                  handleNext(ev);
                }
              }
            }
          }),
          onDropdownVisibleChange: joinFunctions(onDropdownVisibleChange, handleOpenClose)
        }));
      });
    }
  };
};
var _default = exports.default = (0, _redux.compose)(_forceLabelInValue.default, infinteScrollSelect);
function search() {
  let src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let input = arguments.length > 1 ? arguments[1] : undefined;
  return src.toString().trim().toLowerCase().indexOf(input.toString().trim().toLowerCase()) === 0;
}
function joinFunctions() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return fns.filter(fn => !!fn).map(fn => fn.apply(null, args));
  };
}